import png from './images/titans.png'

export const colors = {
  dominant: '#00aae7',
  highlight: '#fcb53e',
}
export const fullname = 'Titans'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/titans.js